import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import { Observable } from 'rxjs'

import { APP_ID_HEADER } from '@flowx/designer/modules/workspaces/shared/commons.types'
import { selectAppId } from '@flowx/designer/shared/store/selectors/router.selectors'

const AI_API_PREFIX = 'ai/api/'

@Injectable()
export class AiAppIdInterceptor implements HttpInterceptor {
  #store = inject(Store)

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(AI_API_PREFIX)) {
      return next.handle(request)
    }

    const appId = this.#store.selectSignal(selectAppId)()
    if (!appId) {
      return next.handle(request)
    }

    return next.handle(request.clone({ setHeaders: { [APP_ID_HEADER]: appId } }))
  }
}
